import _regeneratorRuntime from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _styled from "styled-components";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { formatTemperature } from "../../utils/formatTemperature";
import { ReactComponent as IconMinus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/minuscircleblue.svg";
import { ReactComponent as IconPlus } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/pluscircleblue.svg";
import { ReactComponent as SuccessIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/success.svg";
import { ReactComponent as ShowerIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/menu/hotel-shower-head.svg";
import { usePathCreator } from "../Config/useLinkCreator";
import { useDeviceData } from "../DeviceData/useDeviceData";
import { useDeviceApi } from "../DeviceData/useDeviceApi";
import { Header } from "../Header/Header";
var MAX_TEMP = 55;
var MIN_TEMP = 0;

var Container = _styled.div.withConfig({
  displayName: "HWSPage__Container",
  componentId: "rqb2s1-0"
})(["display:flex;flex-direction:column;"]);

var Title = _styled.div.withConfig({
  displayName: "HWSPage__Title",
  componentId: "rqb2s1-1"
})(["margin-top:60px;font-size:24px;text-align:center;padding:0 40px;"]);

var sizeIconPlusMinus = 50;
var sizeIcon = 60;

var Content = _styled.div.withConfig({
  displayName: "HWSPage__Content",
  componentId: "rqb2s1-2"
})(["margin-top:80px;display:flex;flex-direction:column;align-items:center;"]);

var ModeControl = _styled.div.withConfig({
  displayName: "HWSPage__ModeControl",
  componentId: "rqb2s1-3"
})(["display:flex;margin-top:20px;width:230px;justify-content:space-between;align-items:center;"]);

var IconButton = _styled.button.withConfig({
  displayName: "HWSPage__IconButton",
  componentId: "rqb2s1-4"
})(["background:none transparent;border:0 none;padding:0;display:inline-block;&:focus{outline:0 none;}svg{display:block;}"]);

var IconSymbolContainer = _styled.div.withConfig({
  displayName: "HWSPage__IconSymbolContainer",
  componentId: "rqb2s1-5"
})(["display:flex;flex-direction:column;align-items:center;width:75px;"]);

var CurrentValue = _styled.div.withConfig({
  displayName: "HWSPage__CurrentValue",
  componentId: "rqb2s1-6"
})(["font-size:22px;"]);

export function HWSPage() {
  var _useDeviceData = useDeviceData(),
      heatConfig = _useDeviceData.heatConfig;

  var _useDeviceApi = useDeviceApi(),
      setModeTemperatures = _useDeviceApi.setModeTemperatures;

  var history = useHistory();
  var pathCreator = usePathCreator();

  var _useState = useState(heatConfig.tx.hws),
      _useState2 = _slicedToArray(_useState, 2),
      hwsTemp = _useState2[0],
      setHWSTemp = _useState2[1];

  var handleSaveClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setModeTemperatures({
                variables: {
                  input: {
                    hws: hwsTemp
                  }
                }
              });

            case 2:
              history.push(pathCreator("/"));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSaveClick() {
      return _ref.apply(this, arguments);
    };
  }();

  var decrementDisabled = hwsTemp <= MIN_TEMP;
  var incrementDisabled = hwsTemp >= MAX_TEMP;

  var handleDecrementClick = function handleDecrementClick() {
    setHWSTemp(function (v) {
      return v - 1;
    });
  };

  var handleIncrementClick = function handleIncrementClick() {
    setHWSTemp(function (v) {
      return v + 1;
    });
  };

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: pathCreator("/"),
    actionIcon: SuccessIcon,
    onAction: handleSaveClick
  }), /*#__PURE__*/React.createElement(Title, null, "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0443 \u0413\u0412\u0421"), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(IconSymbolContainer, null, /*#__PURE__*/React.createElement(ShowerIcon, null)), /*#__PURE__*/React.createElement(ModeControl, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: decrementDisabled ? undefined : handleDecrementClick
  }, /*#__PURE__*/React.createElement(IconMinus, {
    fillOpacity: decrementDisabled ? 0.5 : 1,
    height: sizeIconPlusMinus,
    width: sizeIconPlusMinus
  })), /*#__PURE__*/React.createElement(CurrentValue, null, formatTemperature(hwsTemp)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: incrementDisabled ? undefined : handleIncrementClick
  }, /*#__PURE__*/React.createElement(IconPlus, {
    fillOpacity: incrementDisabled ? 0.5 : 1,
    height: sizeIconPlusMinus,
    width: sizeIconPlusMinus
  }))), " "));
}